import React from 'react';
import PropTypes from 'prop-types';
import { getBackgroundByShortName, getShortName } from 'Chore/Utils';

const Avatar = ({ name='', radius='full', avatarUrl = '' }) => {
  const showName = () => {
    return !!avatarUrl?.trim();
  };

  return (showName() ?
    <img alt="failed" className={`avatar`} src={avatarUrl} /> :
    <div className={`avatar v-flex v-items-center v-justify-center v-${getBackgroundByShortName(getShortName(name))}`}>{getShortName(name)}</div>
  );
};

Avatar.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  radius: PropTypes.string
};

export default Avatar;
